export default {
	"dynamicReport": {
		"showWay": "Display mode",
		"beforeShow": "show only front",
		"countData": "Article data",
		"dynamicreportTips": "Only count the data of the user's department",
		"dynamicreportWay": "Summary method",
		"dynamicreportKeyOtherName": "Statistics field alias",
		"enableRoles": "view roles",
		"enableUser": "view user",
		"optionClickHandleTips": "Please select to view roles",
		"selectedValueOfTransferTips": "Please select the person to view",
		"statisticalField": "Statistics field name",
		"searchField": "Field query",
		"groupfieldName": "group field name",
		"format": "Format",
		"dynamicreportKeyName": "Statistics field name",
		"sortKey": "Sort field name",
		"sortingWay": "sort by",
		"permissionsSet": "Permission settings",
		"compositeKeys": "compound field",
		"selectKey": "field selection",
		"cancleDelete": "Undeleted",
		"searchTimeTips": "The fixed query condition must have a time field and the default value cannot be empty",
		"keywordsNotEmptTips": "Statistics field cannot be empty",
		"keyWordWayNotEmptTips": "A default value must be selected for the summary method of statistical fields",
		"fixedSearchKey": "Fixed query conditions"
	},
	"bqReport": {
		"downloadReport": "Download Report",
		"reportTemplate": "Report Template",
		"driverStatusReportByShipment": "Driver Status Report Details by Shipment",
		"driverStatusReportByJob": "Driver Status Report Details by Job",
		"createDate": "Create Date",
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/report/report.js